import React from "react";
import { motion, AnimatePresence } from "framer-motion";

const FooterModal = ({ show, children }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 flex justify-center z-[999]"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="w-full max-w-md">
            <div className="w-screen max-w-md h-screen bg-overlay overflow-y-auto">
              <div className="w-full min-h-screen flex flex-col justify-end">
                <div className="max-w-md w-full bg-secondary-background flex flex-col items-center rounded-t-2xl">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FooterModal;
